import { Link } from "gatsby"
import React from "react"
import { useAppDispatch } from "../state/hooks"
import { toggleMobile } from "../state/menus"
import { PAGES, routes } from "./nav"
import { useAppSelector } from "../state/hooks"
import ContactButton from "./layout/ContactButton"

export function MobileMenu() {
  const dispatch = useAppDispatch()

  const menus = useAppSelector(state => state.menus)
  const { isMobileOpen } = menus

  const transform = isMobileOpen ? "translateY(0)" : "translateY(100%)"
  const linkOpacity = isMobileOpen ? 1 : 0
  const linkTransform = isMobileOpen ? `` : "translateY(20px)"
  const linkTransitionDuration = isMobileOpen ? 0.3 : 0
  const linkTransitionDelayBase = 0.2

  return (
    <div
      className="fixed top-0 z-50 w-full h-full overflow-y-scroll bg-black text-footer-menu md:hidden"
      style={{
        transform,
        transition: "transform 400ms cubic-bezier(0.33, 1, 0.68, 1)",
      }}
    >
      <button
        className="absolute p-3 top-1 left-1"
        onClick={() => {
          dispatch(toggleMobile())
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div className="flex flex-col items-center justify-center pt-16 m-auto text-2xl">
        {routes.map((route, i) => {
          const transitionDelay = linkTransitionDelayBase + i * 0.07

          return (
            <Link
              className="mb-12"
              key={i}
              onClick={() => dispatch(toggleMobile())}
              to={route.path}
              activeClassName="underline"
              partiallyActive={route.page !== PAGES.FEATURED}
              style={{
                opacity: linkOpacity,
                transform: linkTransform,
                transitionProperty: `opacity, transform`,
                transitionDuration: `${linkTransitionDuration}s`,
                transitionTimingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
                transitionDelay: `${transitionDelay}s`,
              }}
            >
              {route.title}
            </Link>
          )
        })}
        <div
          style={{
            opacity: linkOpacity,
            transform: linkTransform,
            transitionProperty: `opacity, transform`,
            transitionDuration: `${linkTransitionDuration}s`,
            transitionTimingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
            transitionDelay: `${(routes.length + 1) * 0.07 + linkTransitionDelayBase
              }s`,
          }}
        >
          <ContactButton visible />
        </div>

        <a
          className="my-12"
          href="https://instagram.com"
          style={{
            opacity: linkOpacity,
            transform: linkTransform,
            transitionProperty: `opacity, transform`,
            transitionDuration: `${linkTransitionDuration}s`,
            transitionTimingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
            transitionDelay: `${(routes.length + 2) * 0.07 + linkTransitionDelayBase
              }s`,
          }}
        >
          <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 4.5046C31.6753 4.5046 32.4659 4.53 35.102 4.65028C37.5395 4.76152 38.8633 5.16879 39.7443 5.51106C40.9111 5.96458 41.744 6.50642 42.6188 7.3812C43.4936 8.25598 44.0354 9.08888 44.4888 10.2557C44.8312 11.1367 45.2385 12.4605 45.3497 14.8979C45.47 17.5341 45.4954 18.3247 45.4954 25.0001C45.4954 31.6754 45.47 32.466 45.3497 35.1021C45.2385 37.5396 44.8312 38.8633 44.4888 39.7444C44.0354 40.9112 43.4936 41.7441 42.6188 42.6189C41.744 43.4937 40.9111 44.0355 39.7443 44.4889C38.8633 44.8313 37.5395 45.2386 35.102 45.3498C32.4663 45.4701 31.6757 45.4955 25 45.4955C18.3242 45.4955 17.5336 45.4701 14.8979 45.3498C12.4604 45.2386 11.1366 44.8313 10.2557 44.4889C9.08878 44.0355 8.25588 43.4937 7.3811 42.6189C6.50632 41.7441 5.96448 40.9112 5.51106 39.7444C5.16869 38.8633 4.76142 37.5396 4.65018 35.1022C4.5299 32.466 4.5045 31.6754 4.5045 25.0001C4.5045 18.3247 4.5299 17.5341 4.65018 14.898C4.76142 12.4605 5.16869 11.1367 5.51106 10.2557C5.96448 9.08888 6.50632 8.25598 7.3811 7.3812C8.25588 6.50642 9.08878 5.96458 10.2557 5.51106C11.1366 5.16879 12.4604 4.76152 14.8978 4.65028C17.534 4.53 18.3246 4.5046 25 4.5046ZM25 0C18.2103 0 17.359 0.0287789 14.6925 0.150444C12.0315 0.271911 10.2142 0.694465 8.62395 1.31252C6.97998 1.95141 5.58579 2.80624 4.19597 4.19607C2.80614 5.58589 1.95131 6.98008 1.31242 8.62405C0.694366 10.2143 0.271812 12.0316 0.150345 14.6926C0.0286797 17.359 0 18.2104 0 25.0001C0 31.7897 0.0286797 32.6411 0.150345 35.3075C0.271812 37.9685 0.694366 39.7858 1.31242 41.376C1.95131 43.0199 2.80614 44.4142 4.19597 45.804C5.58579 47.1939 6.97998 48.0487 8.62395 48.6876C10.2142 49.3056 12.0315 49.7282 14.6925 49.8497C17.359 49.9713 18.2103 50 25 50C31.7896 50 32.641 49.9713 35.3074 49.8497C37.9684 49.7282 39.7857 49.3056 41.3759 48.6876C43.0199 48.0487 44.4141 47.1939 45.8039 45.804C47.1938 44.4142 48.0486 43.02 48.6875 41.376C49.3055 39.7858 49.7281 37.9685 49.8496 35.3075C49.9712 32.6411 50 31.7897 50 25.0001C50 18.2104 49.9712 17.359 49.8496 14.6926C49.7281 12.0316 49.3055 10.2143 48.6875 8.62405C48.0486 6.98008 47.1938 5.58589 45.8039 4.19607C44.4141 2.80624 43.0199 1.95141 41.3759 1.31252C39.7857 0.694465 37.9684 0.271911 35.3074 0.150444C32.641 0.0287789 31.7896 0 25 0ZM25 12.1622C17.9098 12.1622 12.1621 17.9099 12.1621 25.0001C12.1621 32.0902 17.9098 37.8379 25 37.8379C32.0901 37.8379 37.8378 32.0902 37.8378 25.0001C37.8378 17.9099 32.0901 12.1622 25 12.1622ZM25 33.3334C20.3976 33.3334 16.6666 29.6024 16.6666 25.0001C16.6666 20.3977 20.3976 16.6667 25 16.6667C29.6023 16.6667 33.3333 20.3977 33.3333 25.0001C33.3333 29.6024 29.6023 33.3334 25 33.3334ZM41.345 11.655C41.345 13.3118 40.0019 14.655 38.345 14.655C36.6882 14.655 35.345 13.3118 35.345 11.655C35.345 9.99809 36.6882 8.65501 38.345 8.65501C40.0019 8.65501 41.345 9.99809 41.345 11.655Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}
